export default __webpack_public_path__ + "static/media/24.4af15010.jpg";